import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const FunctionInventoryTransfer = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("path", { d: "M9.01,14 L2,14 L2,16 L9.01,16 L9.01,19 L13,15 L9.01,11 L9.01,14 Z M14.99,13 L14.99,10 L22,10 L22,8 L14.99,8 L14.99,5 L11,9 L14.99,13 Z", id: "Shape" })));
};
export default FunctionInventoryTransfer;
